import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const runSteps = [
  {
    number: 1,
    title: 'Trail Preparation',
    description: 'Warm up with dynamic stretches. Pay attention to your footing on uneven terrain and tree roots.'
  },
  {
    number: 2,
    title: 'Forest Rhythm',
    description: 'Let the sounds of nature guide your pace. Feel connected to the earth beneath your feet.'
  },
  {
    number: 3,
    title: 'Mindful Navigation',
    description: 'Stay aware of your surroundings. Watch for changes in terrain and adjust your stride accordingly.'
  },
  {
    number: 4,
    title: 'Nature\'s Therapy',
    description: 'Breathe in the fresh forest air. Let the natural environment rejuvenate your mind and body.'
  }
];

const OutdoorRunSession3: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Outdoor Run Session 3',
      description: 'Completed Outdoor Run Session 3.',
      image: require('../assets/outdoor-run.png').default || require('../assets/outdoor-run.png')
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/outdoor-run');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 3: Forest Trail Run</h1>
              <p className="session-description">
                Immerse yourself in nature's tranquility while running through lush forest trails. Connect with the earth and find peace in movement.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/BKnvF9G5pG8"
                  title="Session 3: Forest Trail Run"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Enjoy Your Run</h2>
                <div className="session-steps">
                  {runSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default OutdoorRunSession3;

